var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { CellLabel } from './cell-label';
var cls = classNames('field-placeholder');
export var FieldPlaceholderDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    display: inline-flex;\n    font-size: ", ";\n  "], ["\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    display: inline-flex;\n    font-size: ", ";\n  "])), theme.COLOR('highlight'), theme.COLOR('line-subtle'), theme.UNIT(3), theme.FONT_SIZE(14))
});
var TypeLabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    border-radius: ", " 0 0 ", ";\n    padding: ", " ", "; \n    border-right: 1px solid ", ";\n    background: ", ";\n  "], ["\n    color: ", ";\n    border-radius: ", " 0 0 ", ";\n    padding: ", " ", "; \n    border-right: 1px solid ", ";\n    background: ", ";\n  "])), theme.COLOR('text'), theme.UNIT(3), theme.UNIT(3), theme.UNIT(2), theme.UNIT(3), theme.COLOR('line-subtle'), theme.COLOR('canvas'))
});
var FieldNameStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n    padding: ", " ", "; \n    border-right: 1px solid ", ";\n  "], ["\n\n    padding: ", " ", "; \n    border-right: 1px solid ", ";\n  "])), theme.UNIT(2), theme.UNIT(3), theme.COLOR('line-subtle'))
});
// -------- Components -------->
var My = {
  NAME: 'FieldPlaceholder',
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  TypeLabel: styled(CellLabel)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), TypeLabelStyles),
  Value: styled(CellLabel)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), FieldNameStyles)
};
export var FieldPlaceholder = function (props) {
  var componentProps = useComponentProps(My.NAME, FieldPlaceholderDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entityTypeLabel = componentProps.entityTypeLabel,
    fieldName = componentProps.fieldName;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.TypeLabel, null, entityTypeLabel), React.createElement(My.Value, null, fieldName));
};
FieldPlaceholder.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;